import { Injectable, Optional } from '@angular/core';
import { Observable, of, empty, EMPTY } from 'rxjs';
import { tap, switchMap, concatMap, catchError } from 'rxjs/operators';
import { Repository, BindingData, Entity, ViewModel, BindingList, EntityPathConverter, BindingObject } from '@farris/devkit';
import { BefRepository, BefRepositoryUtil, BefDataPathUtil } from '@farris/bef';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormNotifyService } from '../form-notify.service';
import { LanguageService } from '../languag.service';
import { FormMessageService } from '../form-message.service';
import { FormErrorService } from '../error/form-error.service';
import { CommandService } from '../command-service';
import { FilterConditionService } from '../filter-condition.service';
import { DataGridService } from '../data-grid.service';
import { DataChangeDetectionService } from '../data-change-detection.service';
// tslint:disable: no-string-literal max-line-length

/**
 * åè¡¨ä»åºæå¡
 */
@Injectable()
class ListDataService {

  /**
   * æé 
   * @param msgService msgService
   * @param repository repository
   * @param bindingData bindingData
   * @param loadingService loadingService
   * @param languageService languageService
   * @param formNotifyService formNotifyService
   * @param formErrorService formErrorService
   * ! @param viewModel viewModel,vmæ¯åææ³¨å¥çï¼èè¡¨åè·åä¸å°ï¼ä¸å®è¦åéç©ºå¤æ­
   * @param filterConditionService filterConditionService
   */
  constructor(
    private msgService: FormMessageService,
    private repository: Repository<any>,
    private bindingData: BindingData,
    private loadingService: FormLoadingService,
    @Optional() private languageService: LanguageService,
    private formNotifyService: FormNotifyService,
    private formErrorService: FormErrorService,
    private viewModel: ViewModel,
    private filterConditionService: FilterConditionService,
  ) {
    if (!languageService) {
      this.languageService = LanguageService.getInstance();
    }

    // if (!filterConditionService) {
    //   this.filterConditionService = new FilterConditionService();
    // }
  }

  /**
   * å è½½
   */
  public load(filter?: string, sort?: string): Observable<Entity[]> {

    // åæ°å¤ç
    filter = !filter ? '[]' : filter;
    sort = !sort ? '[]' : sort;
    // åå¹¶è¿æ»¤æ¡ä»¶
    filter = this.mergeFilterConditions(filter);
    // åå¹¶æåºæ¡ä»¶
    sort = this.mergeSortConditions(sort);

    const loadingTimerId = this.loadingService.showLoadingWithDelay(200);
    const query$ = this.repository.getEntities(JSON.parse(filter), JSON.parse(sort), null, null);
    return query$.pipe(
      tap(
        () => {
          // è§¦åè¿ç«¯åè®¡äºä»¶
          this.fireQueryEvent(filter);
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.loadFailed, error);
        }
      )
    );
  }
  /**
   * è¿æ»¤æ°æ®
   * @param filter è¿æ»¤æ¡ä»¶
   * @param sort æåºæ¡ä»¶
   */
  public filter(filter?: string, sort?: string): Observable<Entity[]> {
    // åæ°å¤ç
    filter = !filter ? '[]' : filter;
    sort = !sort ? '[]' : sort;
    // åå¹¶è¿æ»¤æ¡ä»¶
    filter = this.mergeFilterConditions(filter);
    // åå¹¶æåºæ¡ä»¶
    sort = this.mergeSortConditions(sort);

    const loadingTimerId = this.loadingService.showLoadingWithDelay(200);
    const query$ = this.repository.filter(JSON.parse(filter), JSON.parse(sort));
    return query$.pipe(
      tap(
        () => {
          // è§¦åè¿ç«¯åè®¡äºä»¶
          this.fireQueryEvent(filter);
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.loadFailed, error);
        }
      )
    );
  }
  /**
   * æ¥è¯¢
   */
  public query(filter: string, sort: string, pageSize: number, pageIndex: number): Observable<Entity[]> {
    // åæ°å¤ç
    filter = (filter === '') ? '[]' : filter;
    sort = (sort === '') ? '[]' : sort;
    // åå¹¶è¿æ»¤æ¡ä»¶
    filter = this.mergeFilterConditions(filter);
    // åå¹¶æåºæ¡ä»¶
    sort = this.mergeSortConditions(sort);
    // æ§è¡åæ°
    const loadingTimerId = this.loadingService.showLoadingWithDelay(5);
    const query$ = this.repository.getEntities(JSON.parse(filter), JSON.parse(sort), pageSize, pageIndex);
    return query$.pipe(
      tap(
        () => {
          // è§¦åè¿ç«¯åè®¡äºä»¶
          this.fireQueryEvent(filter);
          this.loadingService.hideDelayLoading(loadingTimerId);
        },
        (error: any) => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.queryFailed, error);
        }
      )
    );
  }

  public queryChild(filter: string, sort: string) {
    // const isUpdateWithPaging = this.viewModel.frameContext.root.params.get('updateWithPaging') || false;
    // if (isUpdateWithPaging) {
    //   return of(null);
    // }
    // tslint:disable-next-line: max-line-length
    const fullPaths = EntityPathConverter.toEntityPathArray(this.viewModel.bindingPath, this.bindingData);
    const paths = fullPaths.slice(0, fullPaths.length - 1);
    // debug
    // tslint:disable-next-line: max-line-length
    const bindingPaths = this.viewModel.bindingPath.split('/').filter(item => item);
    const bindingData = this.viewModel.bindingData;
    let nodeCode = bindingPaths[bindingPaths.length - 1];
    nodeCode = nodeCode.substr(0, nodeCode.length - 1);
    // è·åä¸çº§å®ä½
    const parentPaths = bindingPaths.slice(0, bindingPaths.length - 1);
    const BindingList = bindingData.getValue(parentPaths) as BindingList;
    if (!BindingList) {
      return;
    }
    this.viewModel.frameContext.appContext.params.delete("retrieveing");
    const configPath = `/${nodeCode}`;
    const config = this.repository.entityCollection.getPaginationConfigByPath(configPath);
    if (config) {
      const { pageIndex = 1, pageSize = 0 } = config;
      // pageSize = 0è¡¨ç¤ºæªåé¡µ
      if (pageSize !== 0) {
        this.viewModel.frameContext.appContext.params.set('queryChild', true);
        const request$ = this.repository.queryChild(paths, pageIndex, pageSize);
        return request$.pipe(
          tap(() => { },
            error => {
              this.formErrorService.exception(this.languageService.queryFailed, error);
            }
          )
        );
      }
    }

  }

  /**
   * è·ååé¡µä¿¡æ¯
   * @param nodeCode nodeCode
   * @returns åé¡µä¿¡æ¯ï¼åæ¬ï¼åé¡µå¤§å°ãå½åé¡µç 
   * @description åºæ¬åé¡µä¿¡æ¯å¨åé¡µä¿¡æ¯ä¸­å­å¨æ¶keyä¸ºnodeCode
   */
  /*private getPagingInfo(nodeCode: string) {
    const result: { pageIndex?: number, pageSize?: number } = {};
    const nodeCodePath = `/${nodeCode}`;
    const defaultPagingInfo = this.repository.entityCollection.getPaginationConfigByPath(nodeCodePath);
    const pageSize = defaultPagingInfo && defaultPagingInfo.pageSize || 0;
    const pageIndex = defaultPagingInfo && defaultPagingInfo.pageIndex || 1;
    result.pageIndex = pageIndex;
    result.pageSize = pageSize;
    return result;
  }*/
  /**
   * è¿½å ä¸æ¡æ°æ°æ®
   */
  public append(): Observable<Entity> {
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'append' });
    }
    const append$ = this.repository.append();
    return append$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.appendFailed, error);
        }
      )
    );
  }
  /**
   * å½åè¡åæåæå¥æ°æ®
   * @param position 1 | -1
   */
  public insert(position: 1 | -1 = -1) {
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'insert' });
    }
    const append$ = this.repository.insert(position);
    return append$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.appendFailed, error);
        }
      )
    );
  }

  /**
   * æäº¤åæ´ï¼æ¹éç¼è¾é¡µé¢ï¼è¡åæ¢æ¶æäº¤å¢éï¼
   */
  public updateChanges(): Observable<boolean> {
    const update$ = this.repository.updateAllChanges();
    return update$;
  }

  /**
   * æ¹éä¿å­
   * @param successMsg èªå®ä¹æç¤ºä¿¡æ¯
   */
  public save(successMsg?: string): Observable<boolean> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'save' });
    }
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const save$ = this.repository.applyChanges();
    const result$ = save$.pipe(
      tap(
        () => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          if (successMsg && successMsg.trim()) {
            let showMessage: boolean = true;
            if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
              try {
                const options = JSON.parse(successMsg);
                if (options.showMessage === false) {
                  showMessage = false;
                }
              } catch { }
            }
            if (showMessage !== false) {
              this.formNotifyService.success(successMsg, { hideTitle: true });
            }
          } else {
            this.formNotifyService.success(this.languageService.saveSuccess, { hideTitle: true });
          }
        },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.multiSaveFailed, error);
        }
      )
    );

    return result$;
  }

  /**
   * å é¤
   * @param id è¦å é¤çæ°æ®çid
   * @param ifSave æ¯å¦ä¿å­
   * @param successMsg èªå®ä¹æç¤ºä¿¡æ¯
   * @param confirm æ¯å¦éè¦ç¡®è®¤
   * @param breakable æ¯å¦å¯ä¸­æ­ï¼ifSaveä¸ºfalseæ¶æµä¼ä¸­æ­
   */
  public remove(id: string, ifSave?: boolean | string, successMsg?: string, confirm: boolean | string = true, breakable: boolean | string = true): Observable<any> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'delete' });
    }
    if (!id) {
      this.formNotifyService.warning(this.languageService['plsSelectDeleteData'], { hideTitle: true });
      return empty();
    }
    confirm = (confirm === false || confirm === 'false') ? false : true;
    breakable = (breakable === false || breakable === 'false') ? false : true;
    const action$ = confirm ? this.msgService.question(this.languageService.confirmDeletion) : of(true);
    return action$.pipe(
      concatMap(result => {
        if (!result) {
          return empty();
        }
        ifSave = (ifSave === false || ifSave === 'false') ? false : true;
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        const remove$ = this.repository.removeById(id, ifSave);
        if (!remove$) {
          return empty();
        }
        return remove$.pipe(
          tap(
            () => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              if (successMsg && successMsg.trim()) {
                let showMessage: boolean = true;
                if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                  try {
                    const options = JSON.parse(successMsg);
                    if (options.showMessage === false) {
                      showMessage = false;
                    }
                  } catch { }
                }
                if (showMessage !== false) {
                  this.formNotifyService.success(successMsg, { hideTitle: true });
                }
              } else {
                this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
              }
            },
            error => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.formErrorService.exception(this.languageService.deleteFailed, error);
            }
          ),
          switchMap(() => {
            if (ifSave === true || !breakable) {
              // return this.load();
              return of([]);
            } else {
              // æ¹éç¼è¾åè¡¨è¡¨æ ¼å¤äºç¼è¾æåºæ¯æ¶ï¼ä¸ºé²æ­¢æ§è¡åç»­å½ä»¤å¯¼è´æ°æ®éæ°å è½½ï¼æä»¥å¨æ­¤å°å½ä»¤ä¸­æ­äºãä½åæ¶ä¹å¯¼è´äºå é¤æ°æ®åå¾éè®°å½ä¾ç¶å­å¨ãæä»¥å¨è¿ééè¦åç¬è°ç¨ä¸æ¬¡æ¸ç©ºå¾éæ¹æ³ã
              const datagridService = new DataGridService();
              datagridService.context = this['context'];
              datagridService.uncheckDeletedRows([id]);
              return empty();
            }
          })
        );
      })
    );
  }
  /**
   * æ¹éå é¤
   * @param ids ids
   * @param ifSave æ¯å¦ä¿å­
   * @param successMsg èªå®ä¹æç¤ºä¿¡æ¯
   * @param deleteCurrentRowIfNoChecks æ²¡æå¾éæ¶å é¤å½åè¡
   */
  public removeRows(ids: string[], ifSave?: boolean | string, successMsg?: string, deleteCurrentRowIfNoChecks: boolean | string = false): Observable<any> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'removeRows' });
    }
    deleteCurrentRowIfNoChecks = (deleteCurrentRowIfNoChecks === 'true' || deleteCurrentRowIfNoChecks === true) ? true : false;
    if (!ids || ids.length === 0) {
      const currentId = this.bindingData.list.currentId;
      if (deleteCurrentRowIfNoChecks === true && currentId) {
        ids = [this.bindingData.list.currentId];
      } else {
        this.formNotifyService.warning(this.languageService['plsSelectDeleteData'], { hideTitle: true });
        return empty();
      }
    }
    const action$ = this.msgService.confirm(this.languageService.confirmDeletion);
    return action$.pipe(
      concatMap(result => {
        if (!result) {
          return empty();
        }
        if (typeof ifSave === 'undefined') {
          ifSave = true;
        }
        if (typeof ifSave === 'string') {
          ifSave = ifSave.toLowerCase() === 'false' ? false : true;
        }
        ifSave = (ifSave === false) ? false : true;
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        const remove$ = this.repository.removeByIds(ids, ifSave);

        if (!remove$) {
          return empty();
        }

        return remove$.pipe(
          tap(
            () => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              if (successMsg && successMsg.trim()) {
                let showMessage: boolean = true;
                if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                  try {
                    const options = JSON.parse(successMsg);
                    if (options.showMessage === false) {
                      showMessage = false;
                    }
                  } catch { }
                }
                if (showMessage !== false) {
                  this.formNotifyService.success(successMsg, { hideTitle: true });
                }
              } else {
                this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
              }
              // this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
            },
            error => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.formErrorService.exception(this.languageService.deleteFailed, error);
            }
          ),
          switchMap(() => {
            return of([]);
          })
        );
      })
    );
  }

  /**
   * å é¤åçå·æ°
   */
  public refreshAfterRemoving(loadCmdName: string, loadCmdFrameId: string): Observable<any> {
    if (this.viewModel && loadCmdName && loadCmdFrameId) {
      const commandService = this.viewModel.frameContext.injector.get<CommandService>(CommandService, null);
      return commandService.execute(loadCmdName, loadCmdFrameId);
    }
    return this.load();
  }

  /**
   * å·æ°
   * @param loadCmdName å·æ°å½ä»¤
   * @param loadCmdFrameId å·æ°å½ä»¤æå¨çframeId
   */
  public refresh(loadCmdName: string, loadCmdFrameId: string): Observable<any> {
    if (this.viewModel && loadCmdName && loadCmdFrameId) {
      const commandService = this.viewModel.frameContext.injector.get<CommandService>(CommandService, null);
      return commandService.execute(loadCmdName, loadCmdFrameId);
    }
    return this.load();
  }
  /**
   * åæ¶æ¶æ£æµæªä¿å­è®°å½
   */
  public cancel(): Observable<any> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'cancel' });
    }
    const hasChange$ = DataChangeDetectionService.hasChange(this.viewModel.frameContext);
    return hasChange$.pipe(
      switchMap((changed: boolean) => {
        if (!changed) {
          return this._cancel();
        } else {
          return this.msgService.question(this.languageService['cancelWithoutSave']).pipe(
            switchMap((ifCancel: boolean) => {
              if (ifCancel === false) {
                return EMPTY;
              }
              return this._cancel();
            })
          );
        }
      })
    );
  }
  /**
   * è¿ååæ´é
   * @description ä¸å¸¦åæ´æ£æµæç¤º
   */
  public revert(): Observable<any> {
    return this._cancel();
  }
  /**
   * åæ¶ï¼åé¨åæ¶ï¼
   */
  private _cancel(): Observable<any> {
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const cancel$ = this.repository.cancelChanges();
    return cancel$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.cancelFailed, error);
        }
      )
    );
  }
  /**
   * è·åæ ¹ç»ä»¶appContext
   */
  private get messagePipe() {
    if (this.viewModel && this.viewModel.frameContext) {
      const appContext = this.viewModel.frameContext.getFormAppContext() || null;
      if (appContext) {
        return appContext.messagePipe || null;
      }
    }
    return null;
  }
  /**
   * è§¦åæ¥è¯¢äºä»¶
   * @param filters è¿æ»¤æ¡ä»¶
   */
  private fireQueryEvent(filters: any) {
    const messagePipe = this.messagePipe;
    // const frameId = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.frameId || null;
    if (messagePipe) {
      messagePipe.next({ type: 'query' });
    }
  }
  /**
   * åå¹¶è¿æ»¤æ¡ä»¶
   * @param filter è¡¨åè¿æ»¤æ¡ä»¶
   */
  private mergeFilterConditions(filter: any) {
    if (typeof filter === 'string') {
      filter = JSON.parse(filter) || [];
    }
    const filters: Array<any> = filter;
    const bindingPath = this.viewModel && this.viewModel.bindingPath || null;
    if (bindingPath) {
      const originalConditions = this.viewModel && this.viewModel.frameContext.repository.filterConditionManager.getFilters(bindingPath) || [];
      // this.filterConditionService.getFilters(bindingPath) || [];
      const conditions = Array.from(originalConditions);
      if (conditions && conditions.length > 0) {
        /* filters.forEach((item: any, index: number) => {
          const field = item.FilterField || null;
          if (field) {
            const duplicateIndex = conditions.findIndex(condition => condition.FilterField === field);
            if (duplicateIndex !== -1) {
              filters[index] = conditions[duplicateIndex];
              conditions.splice(duplicateIndex, 1);
            }
          }
        });*/
        // ä¿®æ¹å½ä»¤ä¸è¿æ»¤æ¡ä»¶çæåä¸ä¸ªæ¥è¯¢å³ç³»ä¸ºand
        if (filters.length > 0) {
          // æåä¸ä¸ªè¿æ»¤æ¡ä»¶
          const lastFilter = filters[filters.length - 1];
          if (lastFilter) {
            if (lastFilter.hasOwnProperty('Relation')) {
              delete lastFilter.Relation;
            }
            lastFilter.relation = 1;
          }
        }
        // åå¹¶æ°çè¿æ»¤æ¡ä»¶ååæ¥å½ä»¤ä¸çè¿æ»¤æ¡ä»¶
        filters.push(...conditions);
      }
    }

    return JSON.stringify(filters);
  }
  /**
   * åå¹¶æåºæ¡ä»¶
   * @param sort æåºæ¡ä»¶
   */
  private mergeSortConditions(sort: any) {
    if (typeof sort === 'string') {
      sort = JSON.parse(sort) || [];
    }
    const sorts: Array<any> = sort;
    const bindingPath = this.viewModel && this.viewModel.bindingPath || null;
    if (bindingPath) {
      // è·åå½åç»å®è·¯å¾çæææåºæ¡ä»¶
      const originalConditions = this.viewModel && this.viewModel.frameContext.repository.sortConditionManager.getConditionsByBindingPath(bindingPath, (direction) => {
        if (direction === 'asc') {
          return 0;
        } else { return 1; }
      }) || [];
      const conditions = Array.from(originalConditions);
      // å¦æå½åç»å®è·¯å¾ææåºæ¡ä»¶ï¼åå¿½ç¥å½ä»¤ä¸é¢å¶çæåºæ¡ä»¶
      if (conditions && conditions.length > 0) {
        // éåå·²æçè¿æ»¤æ¡ä»¶ï¼å¦ææéå¤çfieldï¼ç¨åèçè¦çå·²æç
        /* sorts.forEach((item: any, index: number) => {
          const field = item.SortField || null;
          if (field) {
            const duplicateIndex = conditions.findIndex(condition => condition.SortField === field);
            if (duplicateIndex !== -1) {
              sorts[index] = conditions[duplicateIndex];
              conditions.splice(duplicateIndex, 1);
            }
          }
        });*/
        return JSON.stringify(conditions);
        // å°å¶ä½æåºæ¡ä»¶æ·»å å°æåºæ°ç»
        // sorts.push(...conditions);
      }
    }
    return JSON.stringify(sorts);
  }
}
export { ListDataService };
